module.exports = __webpack_public_path__ + "static/media/default_icon.21d662f2.svg";